/* Rootix 10k: Scroll-Hero (Bildsequenz), Einrühren-Moment, Auftritte. Vanilla JS, keine Abhängigkeiten. */
(() => {
  'use strict';
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  // Gleiche fünf Strings wie in rx-10k.css, Zeichen für Zeichen.
  // Static-Gates: muss Zeichen für Zeichen zu rx-10k.css passen. Handy hochkant scrubbt (eigener Bildsatz).
  const GATES = [
    '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
    '(prefers-reduced-motion: reduce)'
  ];
  const MOBILE = matchMedia('(max-width: 720px), (orientation: portrait) and (max-width: 1024px), (orientation: portrait) and (pointer: coarse)');
  const MQLS = GATES.map(q => matchMedia(q));

  document.addEventListener('visibilitychange', () => document.body.classList.toggle('rx-paused', document.hidden));

  /* ---------- Text zerlegen (einmal, mit festem Zufall) ---------- */
  function rng(seed) { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; }
  function split(el, mode, seed) {
    const text = el.textContent.trim();
    const r = rng(seed);
    const sr = document.createElement('span'); sr.className = 'rx-visually-hidden'; sr.textContent = text;
    const vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true');
    const words = text.split(/\s+/);
    const totalChars = text.replace(/\s/g, '').length;
    let ci = 0;
    words.forEach((word, wi) => {
      const w = document.createElement('span'); w.className = 'w';
      w.style.setProperty('--th', (wi / Math.max(1, words.length) * 0.45 + r() * 0.05).toFixed(3));
      if (mode === 'chars') {
        [...word].forEach(ch => {
          const c = document.createElement('span'); c.className = 'c'; c.textContent = ch;
          c.style.setProperty('--th', (ci / totalChars * 0.35 + r() * 0.2).toFixed(3));
          c.style.setProperty('--jx', ((r() - 0.5) * 140).toFixed(1) + 'px');
          c.style.setProperty('--jy', ((r() - 0.5) * 110).toFixed(1) + 'px');
          c.style.setProperty('--jr', ((r() - 0.5) * 60).toFixed(1) + 'deg');
          w.appendChild(c); ci++;
        });
      } else { w.textContent = word; }
      vis.appendChild(w);
      if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
    });
    el.textContent = ''; el.append(sr, vis);
  }

  /* ---------- Pour-Hero ---------- */
  const root = document.querySelector('[data-rx-pour]');
  if (root) initHero(root);

  function initHero(root) {
    const stage = root.querySelector('.rx-pour__stage');
    const canvas = root.querySelector('.rx-pour__canvas');
    const ctx = canvas.getContext('2d', { alpha: false });
    const poster = root.querySelector('.rx-pour__poster');
    const ring = root.querySelector('.rx-ring');
    const mkSet = (n, tpl, prefix, fx, fy, poster) => ({ N: parseInt(n, 10) || 121, tpl, prefix, fx, fy, poster, frames: [], ok: 0, got: 0, started: false, failed: false, loaded: false });
    const SETS = {
      desk: mkSet(root.dataset.frames, root.dataset.frameUrl, 'rx-pour-000', 0.37, 0.5, root.dataset.poster),
      mob: mkSet(root.dataset.framesM, root.dataset.frameUrlM, 'rx-pour-m-000', 0.5, 0.45, root.dataset.posterM)
    };
    let set = MOBILE.matches ? SETS.mob : SETS.desk;
    const frameUrl = (s, i) => s.tpl.replace(s.prefix, s.prefix.slice(0, -3) + String(i).padStart(3, '0'));

    root.querySelectorAll('[data-split]').forEach((el, i) => split(el, el.dataset.split, 7 + i * 31));
    const bands = [...root.querySelectorAll('.rx-band')].map(el => ({ el, a: +el.dataset.a, b: +el.dataset.b, ramp: +el.dataset.ramp || 0, op: -1, k: -1, vis: null }));

    let target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true, scrubOn = false;
    let loadK = 0, loadStart = 0, drawn = -1, cw = 0, ch = 0;

    // Stabil auch wenn die Adressleiste am Handy ein- und ausfährt: Bühne statt innerHeight messen
    function heroProgress() {
      const range = root.offsetHeight - stage.clientHeight;
      return range > 0 ? clamp(-root.getBoundingClientRect().top / range, 0, 1) : 0;
    }
    function sizeCanvas() {
      const dpr = Math.min(2, devicePixelRatio || 1);
      const w = Math.round(canvas.clientWidth * dpr), h = Math.round(canvas.clientHeight * dpr);
      if (w && h && (w !== cw || h !== ch)) { cw = canvas.width = w; ch = canvas.height = h; drawn = -1; }
    }
    function nearestLoaded(i) {
      const f = set.frames;
      if (f[i]) return i;
      for (let d = 1; d < set.N; d++) { if (i - d >= 0 && f[i - d]) return i - d; if (i + d < set.N && f[i + d]) return i + d; }
      return -1;
    }
    function draw(p) {
      const j = nearestLoaded(Math.round(p * (set.N - 1)));
      if (j < 0 || j === drawn || !cw) return;   // nur zeichnen, wenn sich das Bild ändert
      const img = set.frames[j];
      const s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, clamp((cw - dw) * set.fx, cw - dw, 0), clamp((ch - dh) * set.fy, ch - dh, 0), dw, dh);
      drawn = j;
    }
    function updateCaptions(p) {
      const last = bands.length - 1;
      bands.forEach((b, i) => {
        const f = Math.min(0.02, (b.b - b.a) / 3);
        const inn = i === 0 ? (p >= b.a ? 1 : 0) : smoothstep(p, b.a, b.a + f);
        const out = i === last ? 1 : 1 - smoothstep(p, b.b - f, b.b);
        const op = i === 0 ? out : inn * out;
        let k = clamp((p - b.a) / (b.ramp || Math.min(0.025, (b.b - b.a) * 0.35)), 0, 1);
        if (i === 0) k = Math.max(k, loadK);
        if (Math.abs(op - b.op) > 0.004 || (op === 0) !== (b.op === 0)) {
          b.op = op; b.el.style.opacity = op.toFixed(3);
          const v = op > 0.001;
          if (v !== b.vis) { b.vis = v; b.el.style.visibility = v ? 'visible' : 'hidden'; }
        }
        if (Math.abs(k - b.k) > 0.008 || (k === 1 && b.k !== 1) || (k === 0 && b.k !== 0)) { b.k = k; b.el.style.setProperty('--k', k.toFixed(3)); }
      });
    }
    function tick(now) {
      const dt = Math.min(100, now - (lastTick || now)); lastTick = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      if (loadK < 1) { const t = clamp((now - loadStart) / 900, 0, 1); loadK = 1 - Math.pow(1 - t, 3); }
      const settled = Math.abs(target - shown) < 0.0005 && loadK >= 1;
      if (settled) shown = target;
      draw(shown); updateCaptions(shown);
      if (settled || !heroOnScreen) { rafId = null; lastTick = 0; } else rafId = requestAnimationFrame(tick);
    }
    function onScroll() {
      target = heroProgress();
      if (rafId === null && heroOnScreen && scrubOn) rafId = requestAnimationFrame(tick);
    }
    function onResize() { sizeCanvas(); draw(shown); onScroll(); }
    new IntersectionObserver(es => { heroOnScreen = es[0].isIntersecting; if (heroOnScreen) onScroll(); }).observe(root);

    /* Laden: Poster zuerst, dann Frames grob nach fein, ehrlicher Ring, Watchdog. Je Bildsatz einmal. */
    function order(N) {
      const seen = new Set(), out = [];
      for (let step = 16; step >= 1; step = step / 2 | 0) {
        for (let i = 0; i < N; i += step) if (!seen.has(i)) { seen.add(i); out.push(i); }
        if (step === 1) break;
      }
      if (!seen.has(N - 1)) out.splice(1, 0, N - 1);
      return out;
    }
    function syncState() {
      const coarse = Math.ceil(set.N / 16) + 1;
      root.classList.toggle('is-ready', set.ok >= coarse);
      root.classList.toggle('is-loaded', set.loaded);
      root.classList.toggle('is-failed', set.failed && !set.loaded);
      ring.style.setProperty('--ld', Math.round(126 * (1 - set.got / set.N)));
    }
    function startFrames(s) {
      if (s.started) return; s.started = true;
      const queue = order(s.N); let active = 0, lastRing = 0;
      let watchdog = setTimeout(fail, 20000);
      function done(i, img) {
        clearTimeout(watchdog); watchdog = setTimeout(fail, 20000);
        if (img) { s.frames[i] = img; s.ok++; }
        s.got++; active--;
        if (s.got === s.N) { clearTimeout(watchdog); if (s.ok === 0) { fail(); return; } s.loaded = true; }
        const now = performance.now();
        if (s === set && (now - lastRing > 100 || s.loaded || s.ok === Math.ceil(s.N / 16) + 1)) { lastRing = now; syncState(); drawn = -1; draw(shown); }
        pump();
      }
      function pump() {
        while (!s.failed && active < 6 && queue.length) {
          const i = queue.shift(); active++;
          const img = new Image(); img.decoding = 'async';
          img.onload = () => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()).then(() => done(i, img));
          img.onerror = () => done(i, null);
          img.src = frameUrl(s, i);
        }
      }
      function fail() { s.failed = true; if (s === set) syncState(); }
      pump();
    }
    function loadSet(s) {
      poster.style.backgroundImage = "url('" + s.poster + "')";
      if (s.started) return;
      const p = new Image(); let go = () => { go = () => {}; startFrames(s); };
      p.onload = () => go(); p.onerror = () => go(); p.src = s.poster;
      setTimeout(() => go(), 4000);
    }
    function useSet(s) { set = s; drawn = -1; loadSet(s); syncState(); sizeCanvas(); draw(shown); }

    function enableScrub() {
      if (scrubOn) return; scrubOn = true;
      useSet(MOBILE.matches ? SETS.mob : SETS.desk);
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onResize, { passive: true });
      bands.forEach(b => { b.op = -1; b.k = -1; b.vis = null; });
      if (!loadStart) loadStart = performance.now();
      shown = target = heroProgress();
      updateCaptions(shown); draw(shown);
      rafId = null; onScroll(); if (rafId === null) rafId = requestAnimationFrame(tick);
    }
    function disableScrub() {
      if (!scrubOn) return; scrubOn = false;
      removeEventListener('scroll', onScroll); removeEventListener('resize', onResize);
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    }
    function applyHeroMode() { if (MQLS.some(m => m.matches)) disableScrub(); else enableScrub(); }
    MQLS.forEach(m => m.addEventListener('change', applyHeroMode));
    MOBILE.addEventListener('change', () => { if (scrubOn) { useSet(MOBILE.matches ? SETS.mob : SETS.desk); onScroll(); } });
    applyHeroMode();
  }

  /* ---------- Einrühren: gedrückt halten ---------- */
  document.querySelectorAll('[data-rx-stir]').forEach(sec => {
    const btn = sec.querySelector('[data-rx-hold]');
    const label = btn.querySelector('.rx-hold__label');
    const status = sec.querySelector('[data-rx-stir-status]');
    const glass = sec.querySelector('.rx-stir__glass');
    sec.classList.add('js-stir');
    let p = 0, holding = false, raf = null, last = 0, done = false;
    const write = () => { btn.style.setProperty('--p', p.toFixed(3)); glass.style.setProperty('--p', p.toFixed(3)); };
    function finish() {
      done = true; p = 1; write(); sec.classList.add('is-done');
      label.textContent = label.dataset.done;
      status.textContent = status.dataset.doneMsg || 'Eingerührt. Die Werte pro Portion stehen jetzt in der Liste.';
    }
    function reset() { done = false; p = 0; write(); sec.classList.remove('is-done'); label.textContent = label.dataset.idle; status.textContent = ''; }
    function loop(now) {
      const dt = Math.min(64, now - (last || now)); last = now;
      if (holding) p = Math.min(1, p + dt / 1600); else p = Math.max(0, p - dt / 900 * (0.4 + p));
      write();
      if (p >= 1) { holding = false; raf = null; last = 0; finish(); return; }
      if (!holding && p <= 0) { raf = null; last = 0; return; }
      raf = requestAnimationFrame(loop);
    }
    function press(e) {
      if (e) e.preventDefault();
      if (done) { reset(); return; }
      if (RM.matches) { finish(); return; }
      holding = true; if (!raf) raf = requestAnimationFrame(loop);
    }
    function release() { holding = false; if (!raf && p > 0 && !done) raf = requestAnimationFrame(loop); }
    btn.addEventListener('pointerdown', e => { btn.setPointerCapture && btn.setPointerCapture(e.pointerId); press(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => btn.addEventListener(t, release));
    btn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) press(e); });
    btn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') release(); });
    btn.addEventListener('click', e => e.preventDefault());
    btn.addEventListener('contextmenu', e => e.preventDefault());
    let pinned = false;
    if (RM.matches) { finish(); pinned = true; }
    RM.addEventListener('change', e => {
      if (e.matches && !done) { finish(); pinned = true; }
      else if (!e.matches && pinned) { pinned = false; reset(); }
    });
  });


  /* ---------- Sprung-Buttons (#sorten): zuverlässig scrollen, Header berücksichtigen ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a.rx-btn[href^="#"]');
    if (!a) return;
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!id) return;
    const anchor = document.getElementById(id);
    if (!anchor) { if (a.dataset.fallback) { e.preventDefault(); location.href = a.dataset.fallback; } return; }
    e.preventDefault();
    // Ziel ist die Section direkt nach der Sprungmarke (Sortenkarten)
    const wrap = anchor.closest('.shopify-section');
    const target = (wrap && wrap.nextElementSibling) || anchor;
    const header = document.querySelector('.section-header .header-wrapper, sticky-header, .shopify-section-header-sticky');
    const offset = header ? Math.min(header.getBoundingClientRect().height, 120) : 0;
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: RM.matches ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* ---------- Auftritte und selbstzeichnende Linie ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in'); io.unobserve(e.target);
    setTimeout(() => e.target.classList.add('rx-settled'), 1400);   // Staffelung danach zurücknehmen
  }), { threshold: 0.18 });
  document.querySelectorAll('[data-rx-reveal]').forEach(el => io.observe(el));

  const waves = [...document.querySelectorAll('.rx-wave path')];
  if (waves.length) {
    let ticking = false;
    const drawWaves = () => {
      ticking = false;
      waves.forEach(w => {
        if (RM.matches) { w.style.setProperty('--draw', 0); return; }
        const r = w.ownerSVGElement.getBoundingClientRect();
        const t = clamp((innerHeight - r.top) / (innerHeight * 0.6), 0, 1);
        const v = (1 - t).toFixed(3);
        if (w._v !== v) { w._v = v; w.style.setProperty('--draw', v); }
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(drawWaves); } }, { passive: true });
    RM.addEventListener('change', drawWaves);
    drawWaves();
  }
})();
